export const messageErrors = {
  'You cannot upload a file to this company':
    'Você não tem permissão para fazer upload nesta empresa',
  'You cannot upload a file': 'Você não tem permissão para fazer upload',
  'You cannot list files of this company':
    'Você não tem permissão para ver os arquivos desta empresa',
  'You cannot delete a file': 'Você não tem permissão para excluir os arquivos',
  'You cannot access this company': 'Você não tem permissão para ver os arquivos desta empresa',
};
